module.exports = __webpack_public_path__ + "static/img/title-icon1.ad8affe8.png";